module.exports = __webpack_public_path__ + "static/media/global-logo.f9d099c6.png";